<template>
	<div class="sf-flex-column">
		<div class="sf-col sf-col-4">
			<sf-card class="p-0 card_bg">
				<search-bar :scrId="scrId" />
			</sf-card>
		</div>
		<div class="sf-col sf-col-20">
			<el-row :gutter="20" class="h-100 w-100 m-0">
				<el-col :span="9" class="h-100 pl-0">
					<process-table :scrId="scrId" />
				</el-col>
				<el-col :span="15" class="h-100 pr-0">
					<sql-detail-view :scrId="scrId" />
				</el-col>
			</el-row>
		</div>
	</div>
</template>

<script>
import SearchBar from './Search/SearchBar';
import ProcessTable from './Table/ProcessTable';
import SqlDetailView from './SqlDetailView/SqlDetailView';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	components: {
		SearchBar,
		ProcessTable,
		SqlDetailView
	}
};
</script>

<style></style>
